import { Box, Heading, Spinner, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { fetchPickupStats } from "../../api";

const PickupsStatsChart = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadStats = async () => {
            try {
                const res = await fetchPickupStats();
                setData(res.data || []);
            } catch (err) {
                console.error("Error loading stats", err);
            } finally {
                setLoading(false);
            }
        };

        loadStats();
    }, []);

    if (loading) {
        return <Spinner mt={4} />;
    }

    return (
        <Box p={4} borderWidth="1px" borderRadius="lg" boxShadow="md">
            <Heading size="md" mb={4}> EcoCourier - Pickups {new Date().getFullYear()}</Heading>
            {data.length === 0 ? (
                <Text>No pickup data available.</Text>
            ) : (
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={data}>
                        <XAxis dataKey="month" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Bar dataKey="total" name="Pickups" />
                    </BarChart>
                </ResponsiveContainer>
            )}
        </Box>
    );
};

export default PickupsStatsChart;
